import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/components/footer/Footer.css";

const EstaticeFooter = () => {
  return (
    <footer className="ac-footer">
      <Container>
        <Row className="ac-footer__top">

          {/* Col 1 — Brand */}
          <Col lg={5} md={12} className="ac-footer__brand-col">
            <div className="ac-footer__brand">
              <div className="ac-footer__logo-icon">
                <span>E</span>
              </div>
              <div className="ac-footer__logo-text">
                <span className="ac-footer__logo-name">Estatica</span>
                <span className="ac-footer__logo-tagline">SKIN & LASER CLINIC</span>
              </div>
            </div>
            <p className="ac-footer__desc">
              A modern skin & laser clinic built around dermatologist-led care,
              advanced laser technology and treatments tailored to your skin.
            </p>
            <div className="ac-footer__socials">
              {/* Instagram */}
              <span className="ac-footer__social-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none"/>
                </svg>
              </span>
              {/* Facebook */}
              <span className="ac-footer__social-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </span>
              {/* YouTube */}
              <span className="ac-footer__social-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                  <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="currentColor" stroke="none"/>
                </svg>
              </span>
            </div>
          </Col>

          {/* Col 2 — Visit */}
          <Col lg={3} md={6} sm={6} xs={12} className="ac-footer__info-col">
            <h6 className="ac-footer__col-title">Visit</h6>
            <ul className="ac-footer__info-list">
              <li className="ac-footer__info-item">
                <span className="ac-footer__info-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </span>
                <span>14 Wellness Avenue, Medical District</span>
              </li>
              <li className="ac-footer__info-item">
                <span className="ac-footer__info-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </span>
                <span>Open Mon–Sat, 10AM – 8PM</span>
              </li>
            </ul>
          </Col>

          {/* Col 3 — Contact */}
          <Col lg={4} md={6} sm={6} xs={12} className="ac-footer__info-col">
            <h6 className="ac-footer__col-title">Contact</h6>
            <ul className="ac-footer__info-list">
              <li className="ac-footer__info-item">
                <span className="ac-footer__info-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </span>
                <span>care@estaricaclinic.co</span>
              </li>
              <li className="ac-footer__info-item">
                <span className="ac-footer__info-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </span>
                <span>+92 300 0000000</span>
              </li>
            </ul>
          </Col>

        </Row>

        {/* Bottom Bar */}
        {/* <div className="ac-footer__bottom">
          <p className="ac-footer__copyright">
            © 2026 Estatica Skin & Laser Clinic. Healthy skin, professional care.
          </p>

          <ul className="ac-footer__legal-links">
            <li>
              <Link to="/terms-of-service">Terms of Service</Link>
            </li>
            <li className="ac-footer__legal-divider" aria-hidden="true">•</li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
          </ul>
        </div> */}

      </Container>
    </footer>
  );
};

export default EstaticeFooter;